import { CircularProgress, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import chatbubble from "../img/chatbubble.png";
import ideaicon from "../img/ideaicon.png";
import recordingicon from "../img/recordingicon.png";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "20px 5%",
    paddingBottom: "70px",
  },
  hyperlink: {
    color: "#8277FF !important",
    textDecoration: "none",
  },
  imgSize1: {
    width: "30%",
    display: "block",
    maxWidth: "80px",
    alignSelf: "center",
    margin: "10px auto",
  },
  gridItems: {
    textAlign: "center",
  },
  webframe: {
    margin: "30px 0px",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    top: "0",
    left: "0",
    width: "100%",
    maxWidth: "800px",
    height: "450px",
    [theme.breakpoints.down("xs")]: {
      height: "250px",
    },
  },
}));
function Webinar() {
  const [isLoading, SetisLoading] = useState(true);
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>
          Help Topics, Tips and Resources to Learn More About SwiftGrade
        </title>
        <meta
          name="description"
          content="SwiftGrade can grade both paper and online assessments making it great for virtual, in-person, or hybrid learning. Helping teachers reduce grading load for handwritten assessments by 80-90%."
        />
      </Helmet>
      <div className={classes.root}>
        <Typography variant="h4">Webinars:</Typography>

        <Typography variant="h6">Order a webinar:</Typography>
        <Typography>
          To order a private webinar for a group of teachers at your school,
          email us at{" "}
          <a
            href="mailto:support@goswiftgrade.com"
            className={classes.hyperlink}
          >
            support@goswiftgrade.com
          </a>
          .
        </Typography>
        <Typography style={{ marginTop: "10px" }}>
          Here is what you can expect from our webinars:
        </Typography>
        <Grid
          container
          spacing={3}
          direction="row"
          style={{ margin: "30px 0px" }}
        >
          <Grid item xs={12} sm={4} className={classes.gridItems}>
            <img
              src={chatbubble}
              alt="chatbubble"
              className={classes.imgSize1}
            />
            <Typography variant="h6">Interactive</Typography>
            <Typography>Ask questions and get live answers.</Typography>
          </Grid>
          <Grid item xs={12} sm={4} className={classes.gridItems}>
            <img
              src={recordingicon}
              alt="Recording"
              className={classes.imgSize1}
            />
            <Typography variant="h6">Watch Again</Typography>
            <Typography>
              Our presentations are recorded so that you can revisit them at any
              time!
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} className={classes.gridItems}>
            <img src={ideaicon} alt="Idea" className={classes.imgSize1} />
            <Typography variant="h6">Request features</Typography>
            <Typography>
              Request features that you feel would accomodate your personal
              teaching style
            </Typography>
          </Grid>
        </Grid>
        <Typography variant="h5">Pro-D credits:</Typography>
        <Typography>
          Depending on your school or district, attending one of our webinars
          could count towards Pro-D credits.
          <br />
          <br />
          If this is the case, after attending our webinar please contact us at{" "}
          <a
            href="mailto:support@goswiftgrade.com"
            className={classes.hyperlink}
          >
            support@goswiftgrade.com
          </a>{" "}
          to receive our Webinar Completion Certificate via email.
          <br />
          <br />
          Be sure to include your name, your school's name, and the date of
          attendance.
        </Typography>
      </div>
    </>
  );
}

export default Webinar;
